//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import FiltrosGestaoAprovacao from './FiltrosGestaoAprovacao';
import GestaoAprovacaoTabela from './GestaoAprovacaoTabela';
import TransferirModal from './TransferirModal';

export default {
  name: 'GestaoAprovacao',
  components: {
    TransferirModal,
    GestaoAprovacaoTabela,
    FiltrosGestaoAprovacao,
  },
  data() {
    return {
      filtros: {},
      passo: {},
      idPerfilParaModal: null,
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    podeAcessarPagina() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'FLUXO_GEST_APRO').length;
    },
  },
  methods: {
    preencharFiltro(filtros) {
      this.filtros = Object.assign({}, filtros);
    },
    transferirPasso(passo) {
      this.passo = passo;
      this.$refs.transgerirModal.open();
    },
    recarregarUsuariosNoModal(idPerfil) {
      this.idPerfilParaModal = idPerfil;
      this.$nextTick(() => {
        if (this.$refs.transgerirModal) {
          this.$refs.transgerirModal.buscarUsuario();
        }
      });
    },
  },
  mounted() {
    if (!this.podeAcessarPagina) {
      this.$router.push({ name: 'inicio' });
    }
  },
};



// WEBPACK FOOTER //
// ./src/spa/gestao-aprovacao/GestaoAprovacao.vue?vue&type=script&lang=js&